import React, { useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { Label } from 'core';
import { AuthContext } from 'core/components/auth';
import { useToast } from 'core/components/toast/context';
import { mapRevisedQuoteDetails } from 'core/helpers/quoter.service';
import { useStore } from 'core/store';
import { Errors } from '../errors';
import FooterRight from './footer-right';
import useStyles from './footer.styles';

const Footer = ({ hasRejections }) => {
  const classes = useStyles();
  const toast = useToast();
  const {
    quote: { errors: quoteErrors, offer, sendClusterLink }
  } = useStore();
  const session = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const availableQuote = useMemo(() => {
    return offer?.options?.length > 0;
  }, [offer]);

  const handleSubmitLink = useCallback(
    (quote) => {
      setLoading(true);
      const agentInfo = {
        username: session.user.username,
        email: session.user.email,
        phoneNumber: session.user.phoneNumber
      };

      sendClusterLink(offer.id, quote.email, mapRevisedQuoteDetails(quote), agentInfo)
        .then(({ data }) => {
          if (data) {
            toast.notify({
              type: 'success',
              message: `Email sent to ${quote.email}`
            });
            setLoading(false);
          }
        })
        .catch(() => {
          toast.notify({
            type: 'error',
            message: `Failed to send email to ${quote.email}`
          });
          setLoading(false);
        });
    },
    [sendClusterLink, offer, setLoading, toast, session]
  );
  return (
    <div className={classes.floatingContainer}>
      {hasRejections && <Errors errors={quoteErrors} rejection />}
      {offer && (
        <div className={classes.footerContainer}>
          <div className={classes.footerContent}>
            <Label className={classes.title} type="subtitle">
              {availableQuote ? 'We got a new offer!' : 'Offer not available!'}
            </Label>
            <FooterRight handleSubmit={handleSubmitLink} disabled={!availableQuote} loadingEmail={loading} />
          </div>
        </div>
      )}
    </div>
  );
};

Footer.propTypes = {
  hasRejections: PropTypes.bool.isRequired
};

export default Footer;
